
import ProtectedAPIRepository from './ProtectedAPIRepository'
import APIResponseModel from './APIResponseModel'
import Result from './Result'
import LodgingExpensesDataMapper from '../datamapper/LodgingExpensesDataMapper'
import LodgingExpensesRM from '../responsemodel/LodgingExpensesRM'

export default class LodgingExpensesRepository extends ProtectedAPIRepository {
    private LodgingExpensesDataMapper = new LodgingExpensesDataMapper()

    getLodgingExpenses = async (ro?: GetLodgingExpensesObject) => {
        const response = await this.post<APIResponseModel<LodgingExpensesRM>>('/case/listLodging', ro)
        if (response instanceof Result.Success) {
            const data: APIResponseModel<LodgingExpensesRM> = response.data
            if (data.data !== null) {
                const MrdCharges = data.data.items.map((it) => this.LodgingExpensesDataMapper.map(it));
                console.log(MrdCharges,"lodging")
                return new Result.Success({
                    totalItemCount: data.data.total_item_count,
                    items: MrdCharges,
                })
            } else {
                return new Result.Error(0, 'Data is null')
            }
        } else {
            return response
        }
    }


    UpdateLodgingExpenses = async (ro: updateLodgingExpensesObject) => {
        const response = await this.post<APIResponseModel<LodgingExpensesRM>>('/case/updateLodgingExpenses', ro)
        if (response instanceof Result.Success) {
            const data: APIResponseModel<LodgingExpensesRM> = response.data
            if (data.data !== null) {
                const MrdCharges = this.LodgingExpensesDataMapper.map(data.data.items[0])
                return new Result.Success(MrdCharges)
            } else {
                return new Result.Error(0, 'Data is null')
            }
        } else {
            return response
        }
    }

    actionLodgingReceipt = async (ro: ActionLodgingReceiptObject) => {
        const response = await this.post<APIResponseModel<LodgingExpensesRM>>("/case/actionLodgingReceipt", ro);
        if (response instanceof Result.Success) {
            const data: APIResponseModel<LodgingExpensesRM> = response.data;
            if (data.data !== null) {
                console.log(data.data,"actionReceipt");
                const result = this.LodgingExpensesDataMapper.map(data.data.items[0]);
                return new Result.Success(result);
            } else {
                return new Result.Error(0, 'Data is null')
            }
        } else {
            return response
        }
    }

    actionLodgingAmount = async (ro: ActionLodgingAmountObject) => {
        const response = await this.post<APIResponseModel<LodgingExpensesRM>>("/case/actionLodgingAmount", ro);
        if (response instanceof Result.Success) {
            const data: APIResponseModel<LodgingExpensesRM> = response.data;
            if (data.data !== null) {
                const result = this.LodgingExpensesDataMapper.map(data.data.items[0]);
                return new Result.Success(result);
            } else {
                return new Result.Error(0, 'Data is null')
            }
        } else {
            return response
        }
    }
    // removeState = async (StateId: string) => {
    //     const response = await this.delete<APIResponseModel<null>>(`/state/${StateId}`)
    //     return response
    // }

}


export interface GetLodgingExpensesObject {
    search?: string
    limit?: number
    offset?: number
    request_status?: string
    lodging_receipts_status?: string
    start_date?: any,
    end_date?: any
}
export interface ActionLodgingReceiptObject {
    expenseId: string,
    investigatorId: string,
    receiptStatus: string
}
export interface ActionLodgingAmountObject {
    expenseId: string,
    investigatorId: string,
    expenseAmount: string
}
export interface updateLodgingExpensesObject {
    id: string
    status: string
}